import React, { useEffect, useRef, useState, useContext } from "react";
import {
  Grid,
  TextField,
  Typography,
  Paper,
  Switch,
  FormControlLabel,
  Container,
  Box,
  TextareaAutosize,
  Button,
  FormGroup,
  CircularProgress,
} from "@mui/material";
import { MapContainer, TileLayer, Marker } from "react-leaflet";
import Textarea from "@mui/joy/Textarea";
import "leaflet/dist/leaflet.css";
import LocationMarker from "../../ui/Map";
import Dropdown from "../../ui/Dropdown";
import { ImageIcon, VideoIcon, ImageUp, MonitorUp } from "lucide-react";
import { Mutation, useMutation, useMutationState } from "@tanstack/react-query";
import { postCarData, useFetchData } from "../../hooks/useFetchData";
import { useTranslation } from "react-i18next";
import Modall from "../../ui/Modal";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { redirect, useNavigate } from "react-router-dom";
import { formSchemaa, validationSchema } from "../../component/validation";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import CustomerTestimonial from "../../ui/Loading";
import { ToastContainer, toast } from "react-toastify";
import L, { setOptions } from "leaflet";
import customIconUrl from '../Cars/images/car.png'; // Replace with your actual image path
import { usecontextUser } from "../../context/usecontextUser";


let DefaultIcon = L.icon({
  iconUrl: customIconUrl,
  // shadowUrl: iconShadow,
  iconSize: [60, 60],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  // shadowSize: [41, 41],
});
export default function Newcar() {
  const { user } = useContext(usecontextUser)

  L.Marker.prototype.options.icon = DefaultIcon;
  const { data: dataa } = useFetchData(
    "https://3dfinal.tanaghomtech.com/public/api/carscategories"
  );
  const { data: data2 } = useFetchData(
    "https://3dfinal.tanaghomtech.com/public/api/cities"
  );
  console.log("data2", data2);

  const { t } = useTranslation();
  const navigate = useNavigate();
  const [markerPosition, setMarkerPosition] = useState({
    lat: 33.51328081312661,
    lng: 36.27681196925691,
  });
  const [userid, setUserid] = useState(user.id);

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [preview, setPreview] = useState(null);
  const [previeww, setPrevieww] = useState(null);
  const [preview2, setPreview2] = useState(null);
  const [previewvideo, setPreviewvideo] = useState([]);
  const [previewvideoo, setPreviewvideoo] = useState(null);
  const [previeww2, setPrevieww2] = useState(null);
  const [previews, setPreviews] = useState([]);
  const [previewss, setPreviewss] = useState([]);
  const [previewsV, setPreviewsV] = useState([]);
  const [previewssV, setPreviewssV] = useState([]);
  const [checked, setChecked] = useState({});
  const [formDataa, setFormDataa] = useState({});
  const [open, setOpen] = useState();
  const [categorytype, setCategorytype] = useState([]);
  const [citytype, setCitytype] = useState([]);
  const [imageError, setImageError] = useState();
  const im = process.env.REACT_APP_IMAGE;
  const fileInputRef = useRef();
  const openFilePicker = () => {
    fileInputRef.current?.click();
  };
  const [rent, setRent] = useState(null);
  const [unit, setUnit] = useState(null);
  const {
    register,
    handleSubmit,
    formState: { errors },
    trigger,
    getValues,
    control,
    setValue,
  } = useForm({
    resolver: yupResolver(formSchemaa, validationSchema),
  });

  const handleDropdownChange = (label, value) => {
    if (label === "Offer type") {
      setUnit(value); // Update the rent state
    }
  };
  const handleDropdownChange2 = (label, value) => {
    if (label === "unit status") {
      setRent(value); // Update the rent state
    } else if (label === "Category type") {
      const selectedCategory = dataa?.data?.find((item) => item.id === value);
      setCategorytype(selectedCategory);
      console.log("selectedCategory", selectedCategory);
    } else if (label === "Cities") {
      const selectedCity = data2?.data?.find((item) => item.id === value);
      setCitytype(selectedCity);
      console.log(
        "selectedCity",
        data2?.data?.find((item) => item.id === value)
      );
    }
  };

  useEffect(() => {
    handleDropdownChange();
    console.log(typeof unit, unit);
    handleDropdownChange2();
    console.log(typeof rent, rent);
  }, [unit, rent]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (value !== undefined) {
      setFormDataa((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };
  const handleswitch = (e) => {
    const { name, checked: isChecked } = e.target;
    setChecked((prev) => ({
      ...prev,
      [name]: isChecked,
    }));
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith("image/")) {
      setPreview(URL.createObjectURL(file));
      console.log(im);

      setPrevieww(file);
    }
  };
  const handleImageUpload2 = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith("image/")) {
      setPreview2(URL.createObjectURL(file));
      setPrevieww2(file);
    }
  };

  const handleImageUploadvideo = (event) => {
    const files = Array.from(event.target.files);

    // ✅ Filter only video files
    const videoFiles = files.filter((file) => file.type.startsWith("video/"));
    const videoPreviews = videoFiles.map((file) => URL.createObjectURL(file));
    setPreviewssV(videoFiles); // ✅ use this in rendering
    setPreviewsV((prev) => [...prev, ...videoPreviews]); // add new previews to existing ones
  };

  const handleImageUploads = (e, onChange) => {
    const files = Array.from(e.target.files); // convert FileList to an array
    onChange(files);
    const totalImages = previews.length + files.length;
    if (totalImages > 10) {
      setImageError("You can only upload a maximum of 3 images.");
      return;
    }
    if (totalImages < 3) {
      setImageError("You must upload  3 images.");
      return;
    }
    setImageError("");
    setValue("images", files, { shouldValidate: true });
    trigger("images");
    if (files.length === 0) {
      setPreviews([]);
      return;
    }
    const validImages = files.filter((file) => file.type.startsWith("image/"));
    const imagePreviews = validImages.map((file) => URL.createObjectURL(file));
    setPreviewss(files);
    setPreviews((prev) => [...prev, ...imagePreviews]);
  };

  const mutation = useMutation({
    mutationFn: postCarData,
    onSuccess: (data) => {
      console.log("Posted successfully", data.data.post.post_reference);
      setData(data.data.post.post_reference);
    },
    onError: (error) => {
      console.error("Posting failed", error.message);
    },
  });

  const handleOpen = async () => {
    const valid = await trigger([
      "status_id",
      "category_id",
      "city_id",
      "region_id",
      "address",
      "description",
      "car_model_id",
      "car_submodel",
      "car_status_id",
      "made_year",
      "color_id",
      "paintcondition_id",
      "car_transmission_id",
      "motor_counter",
      "motorsize",
      "motordrive_id",
      "carchair_id",
      "petroltype_id",
      "price",
      "seller_id",
      // "rent_id",
      "images",
      "car_image",
    ]);
    if (valid) {
      setOpen(true);
    } else {
      toast.error("complete all required input");
    }
  };

  const handleSubmitt = () => {
    if (!previeww) {
      toast.error(t("AddCar.mainimage2"));
    }

    if (previewss.length < 3) {
      toast.error(t("AddCar.least32"));
    }
    setLoading(true);
    const formData = new FormData();

    // Append coordinates
    formData.append("latitude", markerPosition.lat);
    formData.append("longitude", markerPosition.lng);
    formData.append("user_id", userid);
    const formValues = getValues();
    Object.entries(formValues).forEach(([key, value]) => {
      if (value !== undefined && value !== "") {
        formData.append(key, value);
      }
    });
    Object.entries(checked).forEach(([key, value]) => {
      formData.append(key, value ? 1 : 0);
      console.log(key, value);
    });

    formData.append("car_image", previeww);

    // Append other images
    previewss.forEach((file) => {
      formData.append("images[]", file);
    });
    previewssV.forEach((file) => {
      formData.append("videos[]", file);
    });
    formSchemaa
      .validate(formData, { abortEarly: false })
      .then((validData) => {
        console.log("Valid!", validData);
        // Proceed to send validData to backend
      })
      .catch((validationError) => {
        console.log("notValid!", validationError);
      });
    console.log(formData);

    // Call mutation
    mutation.mutate(formData, {
      onSuccess: (data) => {
        setLoading(false);
        navigate(`/finished/${data.data.post.post_reference}`);
        console.log("Success!");
      },
      onError: (error) => {
        setLoading(false); // Stop loading on error
        toast(error.message);
        console.error("Error occurred");
      },
    });
  };

  return (
    <form onSubmit={handleSubmit(handleSubmitt)}>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "100px",
          }}
        >
          <CustomerTestimonial />
        </div>
      ) : (
        <Container sx={{ overflowY: "auto", mb: 10 }}>
          <Paper
            elevation={10}
            style={{
              backgroundColor: "#fff",
              padding: 0,
              borderRadius: 16,
              marginTop: 16,
              direction: t("directions.dir"),
            }}
          >
            <Typography
              variant="h4"
              sx={{
                mt: 2,
                mb: 2,
                boxShadow:
                  "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
                padding: "8px",
                backgroundColor: "#f3efee",
                display: "inline-block",
                width: "auto",
                fontWeight: "bold",
                fontFamily: "oswald,cairo",
                //   right:'0',
                //   position:'absolute'
              }}
            >
              {t("AddCar.Step1")}
            </Typography>
            <div style={{ padding: "24px" }}>
              <Box
                sx={{
                  width: "100%",
                  gap: 2,
                  maxWidth: "100%",
                  display: "flex",
                  mb: 3,
                }}
              >
                <ToastContainer />
                <Controller
                  name="status_id"
                  control={control}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      label={t("AddCar.unitstatus")}
                      url="unitstatus"
                      value={field.value} // Bind field value
                      onChange={(value) => {
                        field.onChange(value); // Update form state
                        handleDropdownChange("unit status", value); // Update external state
                        setUnit(value); // Update unit state
                      }}
                      error={!!fieldState.error} // Error handling
                      helperText={fieldState.error?.message} // Error message display
                    />
                  )}
                />

                <Controller
                  name="category_id"
                  control={control}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      label={t("AddCar.category")}
                      url="carscategories"
                      value={field.value}
                      onChange={(value) => {
                        field.onChange(value); // Update form state
                        handleDropdownChange2("Category type", value); // Update rent state
                        setRent(value);
                      }}
                      error={!!fieldState.error}
                      helperText={fieldState.error?.message}
                    />
                  )}
                />
              </Box>
              <Grid item xs={12} sx={{ mb: 3 }}>
                <Typography
                  sx={{ fontFamily: "oswald,cairo" }}
                  variant="h5"
                  gutterBottom
                >
                  {t("AddCar.map")}
                </Typography>
                <MapContainer
                  center={[markerPosition.lat, markerPosition.lng]}
                  zoom={13}
                  style={{ height: 400, borderRadius: 10 }}
                >
                  <TileLayer
                    attribution="&copy; OpenStreetMap contributors"
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  />
                  <LocationMarker
                    position={markerPosition}
                    setPosition={setMarkerPosition}
                  />
                </MapContainer>
              </Grid>
              <Box
                sx={{
                  width: "100%",
                  gap: 2,
                  maxWidth: "100%",
                  display: "flex",
                  mb: 3,
                }}
              >
                <Controller
                  name="city_id"
                  control={control}
                  rules={{ required: "City is required" }}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      label={t("AddCar.Cities")}
                      url="cities"
                      value={field.value}
                      onChange={(value) => {
                        field.onChange(value);
                        handleDropdownChange2("Cities", value);
                      }}
                      error={!!fieldState.error}
                      helperText={fieldState.error?.message}
                    />
                  )}
                />
                {citytype && (
                  <Controller
                    name="region_id"
                    control={control}
                    rules={{ required: "region is required" }}
                    render={({ field, fieldState }) => (
                      <Dropdown
                        options={citytype?.regions || []}
                        label={t("AddCar.region")}
                        value={field.value}
                        onChange={field.onChange}
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message}
                      />
                    )}
                  />
                )}
              </Box>
              <Box
                sx={{
                  width: "100%",
                  gap: 2,
                  maxWidth: "100%",
                  display: "flex",
                  mb: 3,
                }}
              >
                <TextField
                  fullWidth
                  {...register("address")}
                  id="fullWidth"
                  name="address"
                  value={formDataa.address || ""}
                  onChange={handleChange}
                  label={
                    <span style={{ display: "flex", alignItems: "center" }}>
                      {t("AddCar.address")}{" "}
                      <span
                        style={{
                          color: "red",
                          fontSize: "25px",
                          marginBottom: "-5px",
                        }}
                      >
                        *
                      </span>
                    </span>
                  }
                  error={!!errors.address}
                  helperText={errors.address?.message}
                />
                <TextField
                  fullWidth
                  onChange={handleChange}
                  value={formDataa.address_en || ""}
                  label={
                    <span style={{ display: "flex", alignItems: "center" }}>
                      {t("AddCar.address_en")}{" "}
                      <span
                        style={{
                          color: "red",
                          fontSize: "25px",
                          marginBottom: "-5px",
                        }}
                      ></span>
                    </span>
                  }
                  id="fullWidth"
                  name="address_en"
                />
              </Box>
              <Box sx={{ mb: 2 }}>
                <label
                  htmlFor="description"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    fontWeight: "400",
                    color: "gray",
                  }}
                >
                  {t("AddCar.description")}{" "}
                  <span
                    style={{ color: "red", fontSize: "20px", marginLeft: 4 }}
                  >
                    *
                  </span>
                </label>
                <label
                  style={{
                    fontWeight: "300",
                    fontWeight: "300",
                    color: "gray",
                  }}
                >
                  {t("AddCar.least100")}
                </label>
                <Textarea
                  id="description"
                  name="description"
                  minRows={4}
                  size="lg"
                  {...register("description")}
                  error={!!errors.description}
                  value={formDataa.description || ""}
                  onChange={handleChange}
                />
                {errors.description && (
                  <Typography variant="caption" color="error">
                    {errors.description.message}
                  </Typography>
                )}

                <Box sx={6}></Box>
              </Box>
              <Box sx={12}>
                <label style={{ fontWeight: "400", color: "gray" }}>
                  {t("AddCar.description_en")}
                </label>
                <Textarea
                  xs={5}
                  minRows={4}
                  {...register("description_en")}
                  size="lg"
                  label="description_en"
                  name="description_en"
                  value={formDataa.description_en || ""}
                  onChange={handleChange}
                />
                <p>{errors.description_en?.message}</p>
                <Box sx={6}></Box>
              </Box>
            </div>
          </Paper>
          <Paper
            elevation={10}
            style={{
              backgroundColor: "#fff",
              padding: 0,
              borderRadius: 16,
              marginTop: 16,
              direction: t("directions.dir"),
            }}
          >
            <Typography
              variant="h4"
              sx={{
                mt: 2,
                mb: 2,
                boxShadow:
                  "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
                padding: "8px",
                backgroundColor: "#f3efee",
                display: "inline-block",
                width: "auto",
                fontWeight: "bold",
                fontFamily: "oswald,cairo",
                //   right:'0',
                //   position:'absolute'
              }}
            >
              {t("AddCar.Step2")}
            </Typography>
            <div style={{ padding: "24px" }}>
              <Box
                sx={{
                  width: "100%",
                  gap: 2,
                  maxWidth: "100%",
                  display: "flex",
                  mb: 3,
                }}
              >
                <Controller
                  name="car_model_id"
                  control={control}
                  rules={{ required: "Car Model is required" }}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      label={t("AddCar.model")}
                      url="carsmodels"
                      value={field.value}
                      onChange={field.onChange}
                      error={!!fieldState.error}
                      helperText={fieldState.error?.message}
                    />
                  )}
                />

                <TextField
                  fullWidth
                  label={
                    <span style={{ display: "flex", alignItems: "center" }}>
                      {t("AddCar.submodel")}{" "}
                      <span
                        style={{
                          color: "red",
                          fontSize: "25px",
                          marginBottom: "-5px",
                        }}
                      >
                        *
                      </span>
                    </span>
                  }
                  {...register("car_submodel")}
                  id="car_submodel"
                  name="car_submodel"
                  value={formDataa.car_submodel || ""}
                  onChange={handleChange}
                  error={!!errors.car_submodel}
                  helperText={errors.car_submodel?.message}
                />

                <Controller
                  name="car_status_id"
                  control={control}
                  rules={{ required: "condition is required" }}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      label={t("AddCar.condition")}
                      url="carstatuses"
                      value={field.value}
                      onChange={field.onChange}
                      error={!!fieldState.error}
                      helperText={fieldState.error?.message}
                    />
                  )}
                />
                <TextField
                  fullWidth
                  label={
                    <span style={{ display: "flex", alignItems: "center" }}>
                      {t("AddCar.made_year")}{" "}
                      <span
                        style={{
                          color: "red",
                          fontSize: "25px",
                          marginBottom: "-5px",
                        }}
                      >
                        *
                      </span>
                    </span>
                  }
                  {...register("made_year")}
                  id="made_year"
                  name="made_year"
                  value={formDataa.made_year || ""}
                  onChange={handleChange}
                  error={!!errors.made_year}
                  helperText={errors.made_year?.message}
                />
              </Box>
              <Box
                sx={{
                  width: "100%",
                  gap: 2,
                  maxWidth: "100%",
                  display: "flex",
                  mb: 3,
                }}
              >
                <Controller
                  name="color_id"
                  control={control}
                  rules={{ required: "Color is required" }}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      label={t("AddCar.carscolors")}
                      url="carscolors"
                      value={field.value}
                      onChange={field.onChange}
                      error={!!fieldState.error}
                      helperText={fieldState.error?.message}
                    />
                  )}
                />

                <Controller
                  name="paintcondition_id"
                  control={control}
                  rules={{ required: "Paint Condition is required" }}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      label={t("AddCar.carspaintcondition")}
                      url="carspaintcondition"
                      value={field.value}
                      onChange={field.onChange}
                      error={!!fieldState.error}
                      helperText={fieldState.error?.message}
                    />
                  )}
                />
                <Controller
                  name="car_transmission_id"
                  control={control}
                  rules={{ required: "condition is required" }}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      label={t("AddCar.carstransmissions")}
                      url="carstransmissions"
                      value={field.value}
                      onChange={field.onChange}
                      error={!!fieldState.error}
                      helperText={fieldState.error?.message}
                    />
                  )}
                />
                <TextField
                  fullWidth
                  label={
                    <span style={{ display: "flex", alignItems: "center" }}>
                      {t("AddCar.motor_counter")}{" "}
                      <span
                        style={{
                          color: "red",
                          fontSize: "25px",
                          marginBottom: "-5px",
                        }}
                      >
                        *
                      </span>
                    </span>
                  }
                  {...register("motor_counter")}
                  id="fullWidth"
                  name="motor_counter"
                  value={formDataa.motor_counter || ""}
                  onChange={handleChange}
                  error={!!errors.motor_counter}
                  helperText={errors.motor_counter?.message}
                />
              </Box>
              <Box
                sx={{
                  width: "100%",
                  gap: 2,
                  maxWidth: "100%",
                  display: "flex",
                  mb: 3,
                }}
              >
                <TextField
                  fullWidth
                  label={
                    <span style={{ display: "flex", alignItems: "center" }}>
                      {t("AddCar.motorsize")}{" "}
                      <span
                        style={{
                          color: "red",
                          fontSize: "25px",
                          marginBottom: "-5px",
                        }}
                      >
                        *
                      </span>
                    </span>
                  }
                  {...register("motorsize")}
                  id="motorsize"
                  name="motorsize"
                  value={formDataa.motorsize || ""}
                  onChange={handleChange}
                  error={!!errors.motorsize}
                  helperText={errors.motorsize?.message}
                />

                <Controller
                  name="motordrive_id"
                  control={control}
                  rules={{ required: "Motor Drive is required" }}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      label={t("AddCar.carsmotors")}
                      url="carsmotors"
                      value={field.value}
                      onChange={field.onChange}
                      error={!!fieldState.error}
                      helperText={fieldState.error?.message}
                    />
                  )}
                />

                <Controller
                  name="carchair_id"
                  control={control}
                  rules={{ required: "Car Chairs type is required" }}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      label={t("AddCar.carschairstypes")}
                      url="carschairstypes"
                      value={field.value}
                      onChange={field.onChange}
                      error={!!fieldState.error}
                      helperText={fieldState.error?.message}
                    />
                  )}
                />

                <Controller
                  name="petroltype_id"
                  control={control}
                  rules={{ required: "Car Petrol type is required" }}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      label={t("AddCar.carspetrols")}
                      url="carspetrols"
                      value={field.value}
                      onChange={field.onChange}
                      error={!!fieldState.error}
                      helperText={fieldState.error?.message}
                    />
                  )}
                />
              </Box>
              <Box
                sx={{
                  width: "100%",
                  gap: 2,
                  maxWidth: "100%",
                  display: "flex",
                  mb: 3,
                }}
              >
                <Controller
                  name="seller_id"
                  control={control}
                  rules={{ required: "condition is required" }}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      label={t("AddCar.sellertype")}
                      url="sellertypes"
                      value={field.value}
                      onChange={field.onChange}
                      error={!!fieldState.error}
                      helperText={fieldState.error?.message}
                    />
                  )}
                />
              </Box>
              <Box
                sx={{
                  width: "100%",
                  gap: 2,
                  maxWidth: "100%",
                  display: "flex",
                  mb: 3,
                }}
              >
                <TextField
                  fullWidth
                  {...register("price")}
                  label={
                    <span style={{ display: "flex", alignItems: "center" }}>
                      {t("AddCar.price")}{" "}
                      <span
                        style={{
                          color: "red",
                          fontSize: "25px",
                          marginBottom: "-5px",
                        }}
                      >
                        *
                      </span>
                    </span>
                  }
                  id="fullWidth"
                  name="price"
                  value={formDataa.price || ""}
                  onChange={handleChange}
                  error={!!errors.price}
                  helperText={errors.price?.message}
                />
                {unit !== 1 && (
                  <Controller
                    name="rent_id"
                    control={control}
                    rules={{ required: "condition is required" }}
                    render={({ field, fieldState }) => (
                      <Dropdown
                        label={t("AddUnit.rentduration")}
                        url="rentdurations"
                        value={field.value}
                        onChange={field.onChange}
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message}
                      />
                    )}
                  />
                )}
              </Box>
              <Box
                sx={{
                  width: "100%",
                  gap: 2,
                  maxWidth: "100%",
                  display: "flex",
                  mb: 3,
                }}
              ></Box>
            </div>
          </Paper>
          <Paper
            elevation={10}
            style={{
              padding: 0,
              borderRadius: 16,
              marginTop: 16,
              display: "flex",
            }}
          >
            <Box
              sx={{
                width: "100%",
                gap: 2,
                maxWidth: "100%",
                mb: 3,
                direction: t("directions.dir"),
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  mt: 2,
                  mb: 2,
                  boxShadow:
                    "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
                  padding: "8px",
                  backgroundColor: "#f3efee",
                  display: "inline-block",
                  width: "auto",
                  fontWeight: "bold",
                  fontFamily: "oswald,cairo",
                  //   right:'0',
                  //   position:'absolute'
                }}
              >
                {t("AddCar.Step3")}
              </Typography>
              <FormGroup sx={{ padding: "16px" }}>
                <Grid container spacing={2}>
                  <Grid size={4}>
                    <FormControlLabel
                      control={
                        <Switch
                          name="gps"
                          checked={checked.gps}
                          onChange={handleswitch}
                        />
                      }
                      label={
                        <Typography
                          sx={{ fontFamily: "Oswald,Cairo" }}
                          fontSize={15}
                        >
                          {t("AddCar.gps")}
                        </Typography>
                      }
                    />
                  </Grid>
                  <Grid size={4}>
                    <FormControlLabel
                      control={
                        <Switch
                          name="bluetooth"
                          checked={checked.bluetooth}
                          onChange={handleswitch}
                        />
                      }
                      label={
                        <Typography
                          sx={{ fontFamily: "Oswald,Cairo" }}
                          fontSize={15}
                        >
                          {t("AddCar.bluetooth")}
                        </Typography>
                      }
                    />
                  </Grid>
                  <Grid size={4}>
                    <FormControlLabel
                      control={
                        <Switch
                          name="aircondition"
                          checked={checked.aircondition}
                          onChange={handleswitch}
                        />
                      }
                      label={
                        <Typography
                          sx={{ fontFamily: "Oswald,Cairo" }}
                          fontSize={15}
                        >
                          {t("AddCar.aircondition")}
                        </Typography>
                      }
                    />
                  </Grid>

                  <Grid size={4}>
                    <FormControlLabel
                      control={
                        <Switch
                          name="cd"
                          checked={checked.cd}
                          onChange={handleswitch}
                        />
                      }
                      label={
                        <Typography
                          sx={{ fontFamily: "Oswald,Cairo" }}
                          fontSize={15}
                        >
                          {t("AddCar.cd")}
                        </Typography>
                      }
                    />
                  </Grid>

                  <Grid size={4}>
                    <FormControlLabel
                      control={
                        <Switch
                          name="touchscreen"
                          checked={checked.touchscreen}
                          onChange={handleswitch}
                        />
                      }
                      label={
                        <Typography
                          sx={{ fontFamily: "Oswald,Cairo" }}
                          fontSize={15}
                        >
                          {t("AddCar.touchscreen")}
                        </Typography>
                      }
                    />
                  </Grid>
                  <Grid size={4}>
                    <FormControlLabel
                      control={
                        <Switch
                          name="abs"
                          sx={{ fontSize: "30px" }}
                          checked={checked.abs}
                          onChange={handleswitch}
                        />
                      }
                      label={
                        <Typography
                          sx={{ fontFamily: "Oswald,Cairo" }}
                          fontSize={15}
                        >
                          {t("AddCar.abs")}
                        </Typography>
                      }
                    />
                  </Grid>

                  <Grid size={4}>
                    <FormControlLabel
                      control={
                        <Switch
                          name="sunroof"
                          checked={checked.sunroof}
                          onChange={handleswitch}
                        />
                      }
                      label={
                        <Typography
                          sx={{ fontFamily: "Oswald,Cairo" }}
                          fontSize={15}
                        >
                          {t("AddCar.sunroof")}
                        </Typography>
                      }
                    />
                  </Grid>
                </Grid>
              </FormGroup>
            </Box>
          </Paper>
          <Paper
            elevation={10}
            style={{
              padding: 0,
              borderRadius: 16,
              marginTop: 16,
              direction: t("directions.dir"),
            }}
          >
            <Typography
              variant="h4"
              sx={{
                mt: 2,
                mb: 2,
                boxShadow:
                  "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
                padding: "8px",
                backgroundColor: "#f3efee",
                display: "inline-block",
                width: "auto",
                fontWeight: "bold",
                fontFamily: "oswald,cairo",
                //   right:'0',
                //   position:'absolute'
              }}
            >
              {t("AddCar.mainimage")}{" "}
              <span
                style={{ color: "red", fontSize: "25px", marginBottom: "-5px" }}
              >
                *
              </span>
            </Typography>

            <Box sx={{ p: 4 }}>
              <Box
                component="label"
                sx={{
                  width: 250,
                  height: 180,
                  border: "1px solid #ddd",
                  borderRadius: 2,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                  backgroundColor: "#fff",
                  overflow: "hidden",
                }}
              >
                {preview ? (
                  <img
                    src={preview}
                    alt="Preview"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <ImageUp size={64} color="black" />
                )}

                <input
                  type="file"
                  accept="image/*"
                  style={{ display: "none" }}
                  ref={fileInputRef}
                  {...register("car_image", {
                    required: "Image is required",
                  })}
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      setValue("car_image", file); // مهم جداً لإرسال الصورة
                      setPreview(URL.createObjectURL(file)); // فقط لو حبيت تعرض preview
                    }
                  }}
                />
              </Box>
              {errors["car_image"] && (
                <Typography variant="h5" color="error">
                  {errors["car_image"].message}
                </Typography>
              )}
            </Box>
          </Paper>

          <Paper
            elevation={10}
            style={{
              padding: 0,
              borderRadius: 16,
              marginTop: 16,
              direction: t("directions.dir"),
            }}
          >
            <Typography
              variant="h4"
              sx={{
                mt: 2,
                mb: 2,
                boxShadow:
                  "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
                padding: "8px",
                backgroundColor: "#f3efee",
                display: "inline-block",
                width: "auto",
                fontWeight: "bold",
                fontFamily: "oswald,cairo",
                //   right:'0',
                //   position:'absolute'
              }}
            >
              {t("AddCar.unitimages")}{" "}
              <span
                style={{ color: "red", fontSize: "25px", marginBottom: "-5px" }}
              >
                *
              </span>
            </Typography>

            <Typography variant="h6" sx={{ color: "gray", padding: "16px" }}>
              {t("AddCar.least3")}
            </Typography>
            {previews.length > 0 && (
              <Button
                variant="contained"
                sx={{ ml: "20px" }}
                onClick={() => setPreviews("")}
              >
                Clear
              </Button>
            )}
            <Box sx={{ p: 4 }}>
              <Box
                component="label"
                htmlFor="images"
                sx={{
                  width: "100%",
                  height: 180,
                  border: "1px solid #ddd",
                  borderRadius: 2,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                  backgroundColor: "#fff",
                  overflow: "hidden",
                }}
              >
                {previews.length > 0 ? (
                  <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                    {previews.map((src, index) => (
                      <img
                        key={index}
                        src={src}
                        alt="Previews"
                        style={{
                          width: "30%",
                          height: "180px",
                          objectFit: "cover",
                        }}
                      />
                    ))}
                  </Box>
                ) : (
                  <ImageUp size={64} color="black" />
                )}

                <input
                  type="file"
                  accept="image/*"
                  id="images"
                  multiple
                  style={{ display: "none" }}
                  {...register("images", {
                    onChange: (e) =>
                      handleImageUploads(
                        e,
                        e.target.files && e.target.files.length
                          ? () => { }
                          : () => { }
                      ),
                  })}
                />
              </Box>
              {imageError && <p style={{ color: "red" }}>{imageError}</p>}
              {errors.images && (
                <p style={{ color: "red" }}>{errors.images.message}</p>
              )}
            </Box>
          </Paper>

          <Paper
            elevation={10}
            style={{
              padding: 0,
              borderRadius: 16,
              marginTop: 16,
              direction: t("directions.dir"),
            }}
          >
            <Typography
              variant="h4"
              sx={{
                mt: 2,
                mb: 2,
                boxShadow:
                  "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
                padding: "8px",
                backgroundColor: "#f3efee",
                display: "inline-block",
                width: "auto",
                fontWeight: "bold",
                fontFamily: "oswald,cairo",
                //   right:'0',
                //   position:'absolute'
              }}
            >
              {t("AddCar.unitvideos")}
            </Typography>

            <Box sx={{ p: 4 }}>
              <Box
                component="label"
                htmlFor="videos"
                sx={{
                  width: "100%",
                  height: 180,
                  border: "1px solid #ddd",
                  borderRadius: 2,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                  backgroundColor: "#fff",
                  overflow: "hidden",
                }}
              >
                {previewsV.length > 0 ? (
                  <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                    {previewsV.map((src, index) => (
                      <video
                        key={index}
                        style={{
                          width: "30%",
                          height: "180px",
                          objectFit: "cover",
                        }}
                        controls
                      >
                        <source src={src} type="video/*" />
                      </video>
                    ))}
                  </Box>
                ) : (
                  <MonitorUp size={64} color="black" />
                )}
                <input
                  {...register("videos")}
                  type="file"
                  accept="video/*"
                  id="videos"
                  multiple
                  style={{ display: "none" }}
                  onChange={handleImageUploadvideo}
                />
              </Box>
              <Grid container>
                <Grid size={10}></Grid>
                <Grid size={2}>
                  <Modall
                    handleOpen={handleOpen}
                    open={open}
                    setOpen={setOpen}
                    handle={handleSubmitt}
                    loading={loading}
                  />
                </Grid>
              </Grid>
            </Box>
          </Paper>
        </Container>
      )}
    </form>
  );
}
